import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/react"
import { Trans, useLingui } from "@lingui/react/macro"
import { Moon, Sun, SunMoon } from "lucide-react"
import { useTheme } from "next-themes"

import { getSelectionKey } from "#/utils"

import { ICON_SIZE } from "../../projects/har/utils"

export function ThemeSwitch() {
  const { t } = useLingui()
  const { theme, setTheme } = useTheme()
  const Icon = theme === "dark" ? Moon : theme === "light" ? Sun : SunMoon

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button disableRipple isIconOnly css="min-w-0 px-2" title="Theme" variant="light">
          <Icon size={ICON_SIZE} />
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        disallowEmptySelection
        aria-label={t`Theme switch`}
        selectedKeys={[theme ?? "system"]}
        selectionMode="single"
        onSelectionChange={id => setTheme(getSelectionKey(id))}
      >
        <DropdownItem key="light">
          <Trans>Light</Trans>
        </DropdownItem>
        <DropdownItem key="dark">
          <Trans>Dark</Trans>
        </DropdownItem>
        <DropdownItem key="system">
          <Trans>System</Trans>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}
